var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

var YT,ytPlayer;
function onYouTubeIframeAPIReady() {
	ytMovie.init("tq0L5AsWj6Q");
}
var ytMovie = {
	id: "",
	total: 0,
	state: 0,
	canPlay: false,
	isPlaying: false,
	init: function(movieID){
		let hasPlayer;
		let playerID = $("#movie_hybrid")[0];
		ytPlayer = new YT.Player(playerID, {
			videoId 	: movieID,
			playerVars 	: {
				autohide	: 1,
				controls	: 1,
				frameborder : 0,
				rel			: 0,
				start		: 0,
				showinfo 	: 0,
				disablekb	: 1,
				wmode		: "transparent",
				autoplay	: 0,
				mute 		: 1,
				playsinline	: 1,
				enablejsapi	: 1,
				iv_load_policy: 3,
				origin: location.protocol + '//' + location.hostname + "/"
			},
			events : {
				onReady: function(e){
					ytPlayer 		= e.target;
					ytMovie.canPlay = true;
				},
				onStateChange: function(e){
					ytMovie.isPlaying = true;
					//console.log(e);
					if(e.data === 0){
						ytPlayer.playVideo();
					}
				},
				onError: function(e){
					var errorstatus = e.data;
				}
			}
		});
	},
	play: function(){
		checkPlay();
		function checkPlay(){
			if(ytMovie.canPlay){
				ytPlayer.playVideo();
			}else{
				setTimeout(function(){
					checkPlay();
				}, 100);
			}
		}
	}
}

var cropZoom = {
	count: 0,
	init: function(){
		plus();
		function plus(){
			cropZoom.count++;
			if(cropZoom.count > 4){
				cropZoom.count = 0;
			}
			$(".wrap_zoom_img").removeClass(function(index, className) {
				return (className.match(/\bzoom\S+/g) || []).join(' ');
			});
			$(".wrap_zoom_img").addClass("zoom" + cropZoom.count);
			setTimeout(function(){
				plus();
			}, 2500);
		}
	}
}